export default {
  title: "Order services",
  untilDeadline: "Not later than {date}",

  startDate: "Available since {date}",
  servicesOrders: "My orders",

  servicesCartBtn: "Cart",
  servicesCatalogBtn: "Catalogue of services"
};
